import { render, staticRenderFns } from "./attr-item.vue?vue&type=template&id=dcf7281a&scoped=true&"
import script from "./attr-item.vue?vue&type=script&lang=js&"
export * from "./attr-item.vue?vue&type=script&lang=js&"
import style0 from "./attr-item.vue?vue&type=style&index=0&id=dcf7281a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf7281a",
  null
  
)

export default component.exports